/**
 * One place asks Settings to open on the OpenRouter key section.
 * The app shell registers the opener. A caller with no shell opens nothing.
 */

let opener = null;

export function registerSettingsOpener(fn) {
  opener = fn;
  return () => {
    if (opener === fn) opener = null;
  };
}

export function openSettingsAtApiKey() {
  if (typeof opener !== 'function') return false;
  opener('api-key');
  return true;
}
